import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class AICypressAttribute extends CypressAttribute {
  static buttons = {
    CLOSE: 'AICypressAttribute:buttons:CLOSE',
    DELETE: 'AICypressAttribute:buttons:DELETE',
    NEXT: 'AICypressAttribute:buttons:NEXT',
    BACK: 'AICypressAttribute:buttons:BACK',
    GENERATE: 'AICypressAttribute:buttons:GENERATE',
    DELETE_EXTRACTED_USER: 'AICypressAttribute:buttons:DELETE_EXTRACTED_USER',
    DISCARD_CHANGES: 'AICypressAttribute:buttons:DISCARD_CHANGES',
    EDIT_EXTRACTED_USER: 'AICypressAttribute:buttons:EDIT_EXTRACTED_USER',
    EXTRACT: 'AICypressAttribute:buttons:EXTRACT',
    EXTRACT_DATA: 'AICypressAttribute:buttons:EXTRACT_DATA',
    NEW_CONTACT: 'AICypressAttribute:buttons:NEW_CONTACT',
    OPEN_IN_ANOTHER_TAB: 'AICypressAttribute:buttons:OPEN_IN_ANOTHER_TAB',
    PICK_EXISTING_CONTACT: 'AICypressAttribute:buttons:PICK_EXISTING_CONTACT',
    SAVE_CHANGES: 'AICypressAttribute:buttons:SAVE_CHANGES',
    SKIP_EXTRACTION: 'AICypressAttribute:buttons:SKIP_EXTRACTION',
    TRY_AGAIN: 'AICypressAttribute:buttons:TRY_AGAIN',
    VALIDATE: 'AICypressAttribute:buttons:VALIDATE',
    MAKE_EDITS: 'AICypressAttribute:buttons:MAKE_EDITS',
    CONFIRM_INFORMATION: 'AICypressAttribute:buttons:CONFIRM_INFORMATION',
    VALIDATE_DATA: 'AICypressAttribute:buttons:VALIDATE_DATA',
    CREATE_EXTRACTED_USER: 'AICypressAttribute:buttons:CREATE_EXTRACTED_USER',
    CONTACT_FORM_TOGGLE: 'AICypressAttribute:buttons:CONTACT_FORM_TOGGLE',
    GENERATE_AI_SUMMARY: 'AICypressAttribute:buttons:GENERATE_AI_SUMMARY',
    REGENERATE_AI_SUMMARY: 'AICypressAttribute:buttons:REGENERATE_AI_SUMMARY',
    DELETE_LAST_SUMMARY: 'AICypressAttribute:buttons:DELETE_LAST_SUMMARY',
    RESEARCH_PERPLEXITY: 'AICypressAttribute:buttons:RESEARCH_PERPLEXITY',
    RESTART: 'AICypressAttribute:buttons:RESTART',
    ASK_CLARA: 'AICypressAttribute:buttons:ASK_CLARA',
    CLARA_NEW_CHAT: 'AICypressAttribute:buttons:CLARA_NEW_CHAT',
    CLARA_HISTORY: 'AICypressAttribute:buttons:CLARA_HISTORY',
    CANCEL_ASK_CLARA: 'AICypressAttribute:buttons:CANCEL_ASK_CLARA',
    ASK_NEW_QUESTION: 'AICypressAttribute:buttons:ASK_NEW_QUESTION',
    ASK_NEW_QUESTION_HISTORY: 'AICypressAttribute:buttons:ASK_NEW_QUESTION_HISTORY',
    ASK_NEW_QUESTION_HISTORY_ICON: 'AICypressAttribute:buttons:ASK_NEW_QUESTION_HISTORY_ICON',
    FEEDBACK_THUMBS_UP: 'AICypressAttribute:buttons:FEEDBACK_THUMBS_UP',
    FEEDBACK_THUMBS_DOWN: 'AICypressAttribute:buttons:FEEDBACK_THUMBS_DOWN',
    CLARA_ANSWER_SOURCES: 'AICypressAttribute:buttons:CLARA_ANSWER_SOURCES',
    CLARA_ANSWER_ADD_TO_LIBRARY: 'AICypressAttribute:buttons:CLARA_ANSWER_ADD_TO_LIBRARY',
    CLARA_FAILED_RESPONSE_ASK_NEW_QUESTION:
      'AICypressAttribute:buttons:CLARA_FAILED_RESPONSE_ASK_NEW_QUESTION',
    CLARA_FAILED_RESPONSE_RELOAD_QUESTION:
      'AICypressAttribute:buttons:CLARA_FAILED_RESPONSE_RELOAD_QUESTION',
    CLARA_FAILED_RESPONSE_EDIT_QUESTION:
      'AICypressAttribute:buttons:CLARA_FAILED_RESPONSE_EDIT_QUESTION',
    CLARA_LEGAL_REASONING_CLOSE_ICON: 'AICypressAttribute:buttons:CLARA_LEGAL_REASONING_CLOSE_ICON',
    CLARA_SUGGESTED_PRODUCT_NO_: 'AICypressAttribute:buttons:CLARA_SUGGESTED_PRODUCT_NO_',
    CLARA_SUGGESTED_JURISIDCTION_NO_: 'AICypressAttribute:buttons:CLARA_SUGGESTED_JURISIDCTION_NO_',
    CLARA_CONVERSATION_EDIT: 'AICypressAttribute:buttons:CLARA_CONVERSATION_EDIT',
    CLARA_CONVERSATION_PIN: 'AICypressAttribute:buttons:CLARA_CONVERSATION_PIN',
    VIEW_PENDING_FEEDBACK: 'AICypressAttribute:buttons:VIEW_PENDING_FEEDBACK',
    CLARA_QUESTION_PILL_CANCEL: 'AICypressAttribute:buttons:CLARA_QUESTION_PILL_CANCEL',
    CLARA_QUESTION_PILL_CONFIRM: 'AICypressAttribute:buttons:CLARA_QUESTION_PILL_CONFIRM',
    CLARA_ADVISOR_STOP: 'AICypressAttribute:buttons:CLARA_ADVISOR_STOP',
    FEEDBACK_BUTTON: 'AICypressAttribute:buttons:FEEDBACK_BUTTON',
    CLARA_FEEDBACK_SUBMIT: 'AICypressAttribute:buttons:CLARA_FEEDBACK_SUBMIT',
    CLARA_FEEDBACK_CANCEL: 'AICypressAttribute:buttons:CLARA_FEEDBACK_CANCEL',
    CLARA_FOR_PLANNERS_LAUNCHER: 'AICypressAttribute:buttons:CLARA_FOR_PLANNERS_LAUNCHER',
    CLARA_FOR_PLANNERS_SEEDED_QUESTION_:
      'AICypressAttribute:buttons:CLARA_FOR_PLANNERS_SEEDED_QUESTION_',
    CLARA_FOR_PLANNERS_ESCALATION_BOOK:
      'AICypressAttribute:buttons:CLARA_FOR_PLANNERS_ESCALATION_BOOK',
    CLARA_FOR_PLANNERS_ESCALATION_COMPARE:
      'AICypressAttribute:buttons:CLARA_FOR_PLANNERS_ESCALATION_COMPARE',
    CLARA_FOR_PLANNERS_SEND: 'AICypressAttribute:buttons:CLARA_FOR_PLANNERS_SEND',
    CLARA_FOR_PLANNERS_TRY_AGAIN: 'AICypressAttribute:buttons:CLARA_FOR_PLANNERS_TRY_AGAIN'
  };

  static inputs = {
    ANOTHER_NAME_IN_WILL: 'AICypressAttribute:inputs:ANOTHER_NAME_IN_WILL',
    TITLE: 'AICypressAttribute:inputs:TITLE',
    HAS_ALIAS: 'AICypressAttribute:inputs:HAS_ALIAS',
    FIRST_NAME: 'AICypressAttribute:inputs:FIRST_NAME',
    MIDDLE_NAME: 'AICypressAttribute:inputs:MIDDLE_NAME',
    LAST_NAME: 'AICypressAttribute:inputs:LAST_NAME',
    LAST_NAME_AT_BIRTH: 'AICypressAttribute:inputs:LAST_NAME_AT_BIRTH',
    SPECIFY_RELATION: 'AICypressAttribute:inputs:SPECIFY_RELATION',
    VIEW_EXTRACTED_DATA_TOGGLE: 'AICypressAttribute:inputs:VIEW_EXTRACTED_DATA_TOGGLE',
    RELATIONSHIP_TO_TESTATOR: 'AICypressAttribute:inputs:RELATIONSHIP_TO_TESTATOR',
    SELECT_CONTACT: 'AICypressAttribute:inputs:SELECT_CONTACT',
    SELECT_EXISTING_ESTATE_ACCOUNT: 'AICypressAttribute:inputs:SELECT_EXISTING_ESTATE_ACCOUNT',
    RESEARCH_REASON: 'AICypressAttribute:inputs:RESEARCH_REASON',
    QUESTION_EDITOR: 'AICypressAttribute:inputs:QUESTION_EDITOR',
    CLARA_PROMPT: 'AICypressAttribute:inputs:CLARA_PROMPT',
    CLARA_QUESTION_PILL_TEXTAREA: 'AICypressAttribute:inputs:CLARA_QUESTION_PILL_TEXTAREA',
    CLARA_FOR_PLANNERS_MESSAGE: 'AICypressAttribute:inputs:CLARA_FOR_PLANNERS_MESSAGE'
  };

  static views = {
    ADMIN_TOOL_TABS: 'AICypressAttribute:views:ADMIN_TOOL_TABS',
    RECORD_MATCH: 'AICypressAttribute:views:RECORD_MATCH',
    RECORD_MATCH_NOTICE: 'AICypressAttribute:views:RECORD_MATCH_NOTICE',
    RECORD_RESOLUTION_CHOICE: 'AICypressAttribute:views:RECORD_RESOLUTION_CHOICE',
    RECORD_CHANGE: 'AICypressAttribute:views:RECORD_CHANGE',
    CREATE_NEW_CONTACT: 'AICypressAttribute:views:CREATE_NEW_CONTACT',
    LINK_TO_EXISTING_CONTACT: 'AICypressAttribute:views:LINK_TO_EXISTING_CONTACT',
    DISTRIBUTION_TREE: 'AICypressAttribute:views:DISTRIBUTION_TREE',
    DOCUMENT_NAME: 'AICypressAttribute:views:DOCUMENT_NAME',
    DOCUMENT_SUB_LABEL: 'AICypressAttribute:views:DOCUMENT_SUB_LABEL',
    EMPTY_STATE_AVATAR: 'AICypressAttribute:views:EMPTY_STATE_AVATAR',
    EXTRACTED_USER_NAME: 'AICypressAttribute:views:EXTRACTED_USER_NAME',
    EXTRACTED_USER_RELATIONSHIP: 'AICypressAttribute:views:EXTRACTED_USER_RELATIONSHIP',
    EXTRACTED_USER_VIEW: 'AICypressAttribute:views:EXTRACTED_USER_VIEW',
    NO_EXTRACTED_USER_FOUND_BANNER: 'AICypressAttribute:views:NO_EXTRACTED_USER_FOUND_BANNER',
    VALIDATE_DATA_BANNER: 'AICypressAttribute:views:VALIDATE_DATA_BANNER',
    VALIDATE_MODAL_DESCRIPTION: 'AICypressAttribute:views:VALIDATE_MODAL_DESCRIPTION',
    PRIMARY_EXECUTOR_COLLAPSE: 'AICypressAttribute:views:PRIMARY_EXECUTOR_COLLAPSE',
    ALTERNATE_EXECUTOR_COLLAPSE: 'AICypressAttribute:views:ALTERNATE_EXECUTOR_COLLAPSE',
    PRIMARY_SPECIFIC_BENEFICIARY_COLLAPSE:
      'AICypressAttribute:views:PRIMARY_SPECIFIC_BENEFICIARY_COLLAPSE',
    ALTERNATE_SPECIFIC_BENEFICIARY_COLLAPSE:
      'AICypressAttribute:views:ALTERNATE_SPECIFIC_BENEFICIARY_COLLAPSE',
    PRIMARY_RESIDUAL_BENEFICIARY_COLLAPSE:
      'AICypressAttribute:views:PRIMARY_RESIDUAL_BENEFICIARY_COLLAPSE',
    ALTERNATE_RESIDUAL_BENEFICIARY_COLLAPSE:
      'AICypressAttribute:views:ALTERNATE_RESIDUAL_BENEFICIARY_COLLAPSE',
    VALIDATED_CHECK_ICON: 'AICypressAttribute:views:VALIDATED_CHECK_ICON',
    VALIDATE_EXECUTOR_DESCRIPTION: 'AICypressAttribute:views:VALIDATE_EXECUTOR_DESCRIPTION',
    VALIDATE_EXECUTOR_TITLE: 'AICypressAttribute:views:VALIDATE_EXECUTOR_TITLE',
    STEP_895621_EXTRACTION_VALIDATED_FEEDBACK_MODAL:
      'AICypressAttribute:views:STEP_895621_EXTRACTION_VALIDATED_FEEDBACK_MODAL',
    SECURE_WILL_EXTRACTIONS_VALIDATED_FEEDBACK_MODAL:
      'AICypressAttribute:views:SECURE_WILL_EXTRACTIONS_VALIDATED_FEEDBACK_MODAL',
    PENDING_SUMMARY_VIEW: 'AICypressAttribute:views:PENDING_SUMMARY_VIEW',
    COMPLETED_SUMMARY_VIEW: 'AICypressAttribute:views:COMPLETED_SUMMARY_VIEW',
    SUMMARY_TIMELINE_VIEW: 'AICypressAttribute:views:SUMMARY_TIMELINE_VIEW',
    ESTATE_CONTEXT: 'AICypressAttribute:views:ESTATE_CONTEXT',
    AI_ANSWER: 'AICypressAttribute:views:AI_ANSWER',
    THANKS_FOR_FEEDBACK: 'AICypressAttribute:views:THANKS_FOR_FEEDBACK',
    CLARA_FEEDBACK_FORM: 'AICypressAttribute:views:CLARA_FEEDBACK_FORM',
    RESTART_TOOLTIP: 'AICypressAttribute:views:RESTART_TOOLTIP',
    CLARA_PROMPT_VIEW: 'AICypressAttribute:views:CLARA_PROMPT_VIEW',
    CLARA_SOURCE_CARD: 'AICypressAttribute:views:CLARA_SOURCE_CARD',
    CLARA_SOURCE_ICON: 'AICypressAttribute:views:CLARA_SOURCE_ICON',
    CLARA_SOURCE_TITLE: 'AICypressAttribute:views:CLARA_SOURCE_TITLE',
    CLARA_SOURCE_CONTENT_LIBRARY_TITLE:
      'AICypressAttribute:views:CLARA_SOURCE_CONTENT_LIBRARY_TITLE',
    CLARA_CITATION_INDEX: 'AICypressAttribute:views:CLARA_CITATION_INDEX',
    CLARA_CITATION_PILL: 'AICypressAttribute:views:CLARA_CITATION_PILL',
    CLARA_GROUPED_CITATION_PILL: 'AICypressAttribute:views:CLARA_GROUPED_CITATION_PILL',
    CLARA_CITATION_SOURCE_PANEL: 'AICypressAttribute:views:CLARA_CITATION_SOURCE_PANEL',
    CLARA_GROUPED_CITATION_SOURCE_PANEL:
      'AICypressAttribute:views:CLARA_GROUPED_CITATION_SOURCE_PANEL',
    CLARA_SOURCE_NAVIGATOR_PREV: 'AICypressAttribute:views:CLARA_SOURCE_NAVIGATOR_PREV',
    CLARA_SOURCE_NAVIGATOR_NEXT: 'AICypressAttribute:views:CLARA_SOURCE_NAVIGATOR_NEXT',
    CLARA_LEGAL_REASONING_SOURCE_CONTENT_QUESTION:
      'AICypressAttribute:views:CLARA_LEGAL_REASONING_SOURCE_CONTENT_QUESTION',
    CLARA_LEGAL_REASONING_SOURCE_CONTENT_ANSWER:
      'AICypressAttribute:views:CLARA_LEGAL_REASONING_SOURCE_CONTENT_ANSWER',
    CLARA_HISTORY_QUESTION_: 'AICypressAttribute:views:CLARA_HISTORY_QUESTION_',
    CLARA_ANSWER_SOURCE_CONTAINER_: 'AICypressAttribute:views:CLARA_ANSWER_SOURCE_CONTAINER_',
    CLARA_SUGGESTED_PRODUCT_VIEW: 'AICypressAttribute:views:CLARA_SUGGESTED_PRODUCT_VIEW',
    CLARA_SUGGESTED_JURISDICTION_VIEW: 'AICypressAttribute:views:CLARA_SUGGESTED_JURISDICTION_VIEW',
    CLARA_THINKING_REPHRASING: 'AICypressAttribute:views:CLARA_THINKING_REPHRASING',
    CLARA_THINKING_SIMILAR_DOCUMENTS: 'AICypressAttribute:views:CLARA_THINKING_SIMILAR_DOCUMENTS',
    CLARA_THINKING_ANSWERING: 'AICypressAttribute:views:CLARA_THINKING_ANSWERING',
    CLARA_THINKING_SIMILAR_DOCUMENT_LIST:
      'AICypressAttribute:views:CLARA_THINKING_SIMILAR_DOCUMENT_LIST',
    CLARA_ANSWER_CONTENT_VIEW: 'AICypressAttribute:views:CLARA_ANSWER_CONTENT_VIEW',
    CLARA_ANSWER_REVEAL_OVERLAY: 'AICypressAttribute:views:CLARA_ANSWER_REVEAL_OVERLAY',
    CLARA_TEXTAREA_CONTAINER: 'AICypressAttribute:views:CLARA_TEXTAREA_CONTAINER',
    CLARA_QUESTION_INPUT_STATUS: 'AICypressAttribute:views:CLARA_QUESTION_INPUT_STATUS',
    CLARA_SIDEBAR_PINNED_CONVERSATIONS:
      'AICypressAttribute:views:CLARA_SIDEBAR_PINNED_CONVERSATIONS',
    CLARA_SIDEBAR_UNPINNED_CONVERSATIONS:
      'AICypressAttribute:views:CLARA_SIDEBAR_UNPINNED_CONVERSATIONS',
    CLARA_QUESTION_PILL: 'AICypressAttribute:views:CLARA_QUESTION_PILL',
    CLARA_SUGGESTION_ITEM: 'AICypressAttribute:views:CLARA_SUGGESTION_ITEM',
    CLARA_ESTATE_SUGGESTION_ITEM: 'AICypressAttribute:views:CLARA_ESTATE_SUGGESTION_ITEM',
    CLARA_FOR_PLANNERS_WELCOME: 'AICypressAttribute:views:CLARA_FOR_PLANNERS_WELCOME',
    CLARA_FOR_PLANNERS_CONTEXT_HEADER: 'AICypressAttribute:views:CLARA_FOR_PLANNERS_CONTEXT_HEADER',
    CLARA_FOR_PLANNERS_RESIZE_HANDLE: 'AICypressAttribute:views:CLARA_FOR_PLANNERS_RESIZE_HANDLE',
    CLARA_FOR_PLANNERS_ESCALATION_CARD:
      'AICypressAttribute:views:CLARA_FOR_PLANNERS_ESCALATION_CARD',
    CLARA_FOR_PLANNERS_ESCALATION_REQUEST:
      'AICypressAttribute:views:CLARA_FOR_PLANNERS_ESCALATION_REQUEST',
    CLARA_FOR_PLANNERS_ESCALATION_CONFIRMATION:
      'AICypressAttribute:views:CLARA_FOR_PLANNERS_ESCALATION_CONFIRMATION',
    CLARA_FOR_PLANNERS_SEEDED_QUESTIONS:
      'AICypressAttribute:views:CLARA_FOR_PLANNERS_SEEDED_QUESTIONS',
    CLARA_ADVISOR_SEARCH_FORM: 'AICypressAttribute:views:CLARA_ADVISOR_SEARCH_FORM',
    CLARA_ESTATE_CONVERSATION_VIEW: 'AICypressAttribute:views:CLARA_ESTATE_CONVERSATION_VIEW',
    CLARA_DOCUMENT_ANALYSIS_LOADING_STATE:
      'AICypressAttribute:views:CLARA_DOCUMENT_ANALYSIS_LOADING_STATE',
    CLARA_DOCUMENT_ANALYSIS_LOADING_TITLE:
      'AICypressAttribute:views:CLARA_DOCUMENT_ANALYSIS_LOADING_TITLE',
    CLARA_DOCUMENT_ANALYSIS_STOP_BUTTON:
      'AICypressAttribute:views:CLARA_DOCUMENT_ANALYSIS_STOP_BUTTON'
  };

  static clara = {
    views: {
      DASHBOARD: 'AICypressAttribute:clara:views:DASHBOARD',
      CONVERSATION_VIEW: 'AICypressAttribute:clara:views:CONVERSATION_VIEW'
    }
  };

  static batchReview = {
    views: {
      ANALYSIS: 'AICypressAttribute:batchReview:views:ANALYSIS',
      ANALYSIS_ERROR: 'AICypressAttribute:batchReview:views:ANALYSIS_ERROR',
      TABS: 'AICypressAttribute:batchReview:views:TABS',
      TABS_DISCLAIMER: 'AICypressAttribute:batchReview:views:TABS_DISCLAIMER',
      tabFn: (key: string): string => `AICypressAttribute:batchReview:views:TAB-${key}`,
      tabCountFn: (key: string): string => `AICypressAttribute:batchReview:views:TAB_COUNT-${key}`,
      tabPendingReviewFn: (key: string): string =>
        `AICypressAttribute:batchReview:views:TAB_PENDING_REVIEW-${key}`,
      TABS_HEADER: 'AICypressAttribute:batchReview:views:TABS_HEADER',
      TAB_HEADER_SELECT_ALL: 'AICypressAttribute:batchReview:views:TAB_HEADER_SELECT_ALL',
      IMPORT_FOOTER: 'AICypressAttribute:batchReview:views:IMPORT_FOOTER',
      IMPORT_FOOTER_LABEL: 'AICypressAttribute:batchReview:views:IMPORT_FOOTER_LABEL',
      IMPORT_FOOTER_DESCRIPTION: 'AICypressAttribute:batchReview:views:IMPORT_FOOTER_DESCRIPTION',
      recordCardFn: (type: string): string =>
        `AICypressAttribute:batchReview:views:RECORD_CARD-${type}`,
      RECORD_CARD_NAME: 'AICypressAttribute:batchReview:views:RECORD_CARD_NAME',
      RECORD_CARD_PRICE_AMOUNT: 'AICypressAttribute:batchReview:views:RECORD_CARD_PRICE_AMOUNT',
      RECORD_CARD_PRICE_SUB_LABEL:
        'AICypressAttribute:batchReview:views:RECORD_CARD_PRICE_SUB_LABEL',
      RECORD_CARD_AMOUNT: 'AICypressAttribute:batchReview:views:RECORD_CARD_AMOUNT',
      RECORD_CARD_AMOUNT_SUB_LABEL:
        'AICypressAttribute:batchReview:views:RECORD_CARD_AMOUNT_SUB_LABEL',
      RECORD_CARD_AVATAR: 'AICypressAttribute:batchReview:views:RECORD_CARD_AVATAR',
      RECORD_CARD_RELATIONSHIP: 'AICypressAttribute:batchReview:views:RECORD_CARD_RELATIONSHIP'
    },
    buttons: {
      EDIT_RECORD: 'AICypressAttribute:batchReview:buttons:EDIT_RECORD',
      IMPORT: 'AICypressAttribute:batchReview:buttons:IMPORT',
      DISCARD: 'AICypressAttribute:batchReview:buttons:DISCARD'
    }
  };

  static contentLibrary = {
    views: {
      CONTENT_LIBRARY_TABLE: 'AICypressAttribute:contentLibrary:views:CONTENT_LIBRARY_TABLE',
      HIDDEN_JURISDICTION_COUNT:
        'AICypressAttribute:contentLibrary:views:HIDDEN_JURISDICTION_COUNT',
      PLAN_TYPE_CELL: 'AICypressAttribute:contentLibrary:views:PLAN_TYPE_CELL',
      SUCCESS_ICON: 'AICypressAttribute:contentLibrary:views:SUCCESS_ICON',
      ERROR_ICON: 'AICypressAttribute:contentLibrary:views:ERROR_ICON',
      LOADING_ICON: 'AICypressAttribute:contentLibrary:views:LOADING_ICON',
      PUBLISH_TOOLTIP: 'AICypressAttribute:contentLibrary:views:PUBLISH_TOOLTIP',
      LAST_EDITED_ON: 'AICypressAttribute:contentLibrary:views:LAST_EDITED_ON',
      PDF_PREVIEW: 'AICypressAttribute:contentLibrary:views:PDF_PREVIEW',
      CONTENT_LIBRARY_UPLOAD_TEXT: 'AICypressAttribute:views:CONTENT_LIBRARY_UPLOAD_TEXT'
    },
    buttons: {
      ADD_CONTENT: 'AICypressAttribute:contentLibrary:buttons:ADD_CONTENT',
      EMPTY_STATE_ADD_CONTENT: 'AICypressAttribute:contentLibrary:buttons:EMPTY_STATE_ADD_CONTENT',
      LEAVE: 'AICypressAttribute:contentLibrary:buttons:LEAVE',
      SAVE_DRAFT: 'AICypressAttribute:contentLibrary:buttons:SAVE_DRAFT',
      PUBLISH: 'AICypressAttribute:contentLibrary:buttons:PUBLISH',
      UNPUBLISH: 'AICypressAttribute:contentLibrary:buttons:UNPUBLISH',
      IMPORT: 'AICypressAttribute:contentLibrary:buttons:IMPORT',
      IMPORT_AND_PUBLISH: 'AICypressAttribute:contentLibrary:buttons:IMPORT_AND_PUBLISH',
      DELETE: 'AICypressAttribute:contentLibrary:buttons:DELETE',
      SOURCE_TITLE: 'AICypressAttribute:contentLibrary:buttons:SOURCE_TITLE',
      GENERAL_CONTENT_TYPE: 'AICypressAttribute:contentLibrary:buttons:GENERAL_CONTENT_TYPE',
      SPECIFIC_CONTENT_TYPE: 'AICypressAttribute:contentLibrary:buttons:SPECIFIC_CONTENT_TYPE',
      REMOVE_PDF: 'AICypressAttribute:contentLibrary:buttons:REMOVE_PDF',
      ACTIONS_DROPDOWN: 'AICypressAttribute:contentLibrary:buttons:ACTIONS_DROPDOWN'
    },
    inputs: {
      CONTENT_ESTATE_TYPE_FILTER:
        'AICypressAttribute:contentLibrary:inputs:CONTENT_ESTATE_TYPE_FILTER',
      CONTENT_STATUS_FILTER: 'AICypressAttribute:contentLibrary:inputs:CONTENT_STATUS_FILTER',
      ESTATE_TYPE: 'AICypressAttribute:contentLibrary:inputs:ESTATE_TYPE',
      TITLE: 'AICypressAttribute:contentLibrary:inputs:TITLE',
      URL: 'AICypressAttribute:contentLibrary:inputs:URL',
      COUNTRY: 'AICypressAttribute:contentLibrary:inputs:COUNTRY',
      JURISDICTION: 'AICypressAttribute:contentLibrary:inputs:JURISDICTION',
      COUNTY: 'AICypressAttribute:contentLibrary:inputs:COUNTY',
      MARKDOWN_EDITOR: 'AICypressAttribute:contentLibrary:inputs:MARKDOWN_EDITOR',
      PDF_UPLOAD: 'AICypressAttribute:contentLibrary:inputs:PDF_UPLOAD',
      JSON_UPLOAD: 'AICypressAttribute:contentLibrary:inputs:JSON_UPLOAD',
      ROLES: 'AICypressAttribute:contentLibrary:inputs:ROLES',
      SOURCE_LAST_UPDATED_AT: 'AICypressAttribute:contentLibrary:inputs:SOURCE_LAST_UPDATED_AT',
      EDITOR_MODE: 'AICypressAttribute:contentLibrary:inputs:EDITOR_MODE',
      BULK_UPLOAD: 'AICypressAttribute:contentLibrary:inputs:BULK_UPLOAD',
      QUESTION: 'AICypressAttribute:contentLibrary:inputs:QUESTION',
      ANSWER: 'AICypressAttribute:contentLibrary:inputs:ANSWER',
      PLAN_TYPE: 'AICypressAttribute:contentLibrary:inputs:PLAN_TYPE'
    }
  };
}
